"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _pointer = _interopRequireDefault(require("@/components/customPage/pointer.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    pointer: _pointer.default
  },
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    }
  },
  data: function data() {
    return {
      defaultData: [{
        address_long_lat: '',
        address_name: '',
        addtop: 1,
        album_access_uv: 1,
        album_config: '',
        album_type: 1,
        bond_bid_ratio: 0,
        bond_type: 1,
        check_user_idCard: 1,
        click_num: 0,
        commission: 10,
        commission_config_json: '{"validity_hour":"24","after_commission":"15"}',
        ctime: 1628841385,
        end30: 1,
        end30_mp: 0,
        end_type: 1,
        etime: '2021-08-15 15:56:00',
        fee_rate: '',
        fee_type: 'CNY',
        first_end_time: 1629014160,
        group_backward_count: 10,
        id: 57930,
        image: 'https://artimg2.artart.cn/image/20210813/3b0e28fe2851059a7739ae4a78ec155b.jpg!120a',
        image_show_style: 2,
        is_show: 1,
        is_show_turnovers: 1,
        is_start_can_pay_bond: 1,
        isdel: 0,
        isend: 0,
        issend: 1,
        issendmp: 0,
        istui: 1,
        last_offer_price_time: 5,
        live_id: 0,
        message: '',
        money: 500000,
        msg_desc: '',
        name: '测试实名认证',
        number_group_id: 0,
        orgid: 34173,
        page_notice_msg: '',
        paimai_sum: 2,
        pm_delay_time: 0,
        pm_list_num: 2,
        pmstate: 2,
        postuid: 0,
        presenter_uid: 0,
        prizwhel_activity_id: 0,
        reset_time: 5,
        rotation_img_show: 0,
        scenecon_uid: '',
        scheduled_show_time: 1628841360,
        share_count: 0,
        shop_id: 0,
        showorder: 0,
        status: 0,
        stime: '2021-08-13 15:56:00',
        sys_auction_num: 0,
        tx_video_url: '',
        update_time: '2021-08-15 15:56:01',
        venue_id: 0,
        video: '',
        virtual_click_num: 100,
        sum_price: '1020334.99'
      }, {
        address_long_lat: '',
        address_name: '',
        addtop: 1,
        album_access_uv: 1,
        album_config: '',
        album_type: 1,
        bond_bid_ratio: 0,
        bond_type: 1,
        check_user_idCard: 1,
        click_num: 0,
        commission: 0,
        ctime: 1628841385,
        end30: 1,
        end30_mp: 0,
        end_type: 1,
        etime: '2021-08-15 15:56:00',
        fee_rate: '',
        fee_type: 'CNY',
        first_end_time: 1629014160,
        group_backward_count: 10,
        id: 57930,
        image: 'https://artimg2.artart.cn/image/20210813/3b0e28fe2851059a7739ae4a78ec155b.jpg!120a',
        image_show_style: 1,
        is_show: 1,
        is_show_turnovers: 1,
        is_start_can_pay_bond: 1,
        isdel: 0,
        isend: 0,
        issend: 1,
        issendmp: 0,
        istui: 1,
        last_offer_price_time: 5,
        live_id: 0,
        message: '',
        money: 0,
        msg_desc: '',
        name: '测试实名认证',
        number_group_id: 0,
        orgid: 34173,
        page_notice_msg: '',
        paimai_sum: 2,
        pm_delay_time: 0,
        pm_list_num: 2,
        pmstate: 2,
        postuid: 0,
        presenter_uid: 0,
        prizwhel_activity_id: 0,
        reset_time: 5,
        rotation_img_show: 0,
        scenecon_uid: '',
        scheduled_show_time: 1628841360,
        share_count: 0,
        shop_id: 0,
        showorder: 0,
        status: 0,
        stime: '2021-08-13 15:56:00',
        sys_auction_num: 0,
        tx_video_url: '',
        update_time: '2021-08-15 15:56:01',
        venue_id: 0,
        video: '',
        virtual_click_num: 0
      }]
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {
    albumMargin: function albumMargin() {
      if (this.content.style === 1) {
        return "0 ".concat(this.facade.item_padding / 2, "px 0 0");
      } else {
        return "".concat(this.facade.item_padding / 2, "px ").concat(this.facade.page_padding / 2, "px 0 ").concat(this.facade.page_padding / 2, "px");
      }
    },
    albumWidth: function albumWidth() {
      if (this.content.style === 1) {
        return (750 - this.facade.page_padding - this.facade.page_padding - this.facade.item_padding - 56) / 2 + 'px';
      } else {
        return (750 - this.facade.page_padding - this.facade.page_padding) / 2 + 'px';
      }
    },
    isComponent: function isComponent() {
      return this.$route.name === 'basicsDiy';
    },
    viewData: function viewData() {
      if (this.content.type === 2 && this.content.data && this.content.data.length > 0) {
        return this.content.data;
      } else {
        return this.defaultData;
      }
    },
    contentPadding: function contentPadding() {
      if (this.content.style === 1) {
        return "0 ".concat(this.facade.item_padding / 2, "px");
      } else {
        return 0;
      }
    }
  },
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面渲染前
   * @return {[type]} [description]
   */
  created: function created() {},
  /**
   * 页面加载执行
   * @return {[type]} [description]
   */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {}
};
exports.default = _default;